import React from 'react';
import FitnessProfileHealthMetricCard from '../shared/FitnessProfileHealthMetricCard';

export default function FitnessProfileMetricsRow({
	profile,
	weightDisplay,
	bloodPressureDisplay
}) {
	return (
		<div className="mt-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
			<FitnessProfileHealthMetricCard label="Age" value={profile.age != null ? profile.age : '—'} />
			<FitnessProfileHealthMetricCard
				label="Height"
				value={profile.height || profile.height_display || '—'}
			/>
			<FitnessProfileHealthMetricCard label="Weight" value={weightDisplay} />
			<FitnessProfileHealthMetricCard label="Blood Pressure" value={bloodPressureDisplay} />
			<FitnessProfileHealthMetricCard
				label="Sleep Avg"
				value={
					profile.current_questionnaire?.sleep_hours != null
						? `${profile.current_questionnaire.sleep_hours} hrs`
						: '—'
				}
			/>
		</div>
	);
}
